/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useContext } from 'react';
import { Fieldset } from 'sarsaparilla';
import PropTypes from 'prop-types';

import { LayoutControlContext } from './DetailedAvailabilityPageLayout';

function DetailedAvailabilityFilterItem({ id, children, mobileLabel }) {
    const { isMobileApp } = useContext(LayoutControlContext);

    if (isMobileApp && mobileLabel) {
        return (
            <Fieldset id={id} label={mobileLabel} isLabelVisible>
                {children}
            </Fieldset>
        );
    }

    return children;
}

DetailedAvailabilityFilterItem.propTypes = {
    id: PropTypes.string,
    children: PropTypes.node,
    mobileLabel: PropTypes.string,
};

export default DetailedAvailabilityFilterItem;
